import React from 'react';
import { Button } from '@material-ui/core';
import { EditableQuestion } from '../../../../../../types';
import { UseFormHandleSubmit } from 'react-hook-form';
import { useSaveQuestion } from './hooks/useSaveQuestion';

interface Props {
  question: EditableQuestion;
  handleSubmit: UseFormHandleSubmit<EditableQuestion>;
}

const SaveButton = ({ handleSubmit, question }: Props) => {
  const saveQuestion = useSaveQuestion(question);

  return (
    <Button onClick={handleSubmit(saveQuestion)} variant="contained" color="secondary">
      Save
    </Button>
  );
};

export default SaveButton;
